import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '@/services/api.config';
import { useLockedFeatures } from '@/providers/LockedFeatures.provider';

const { api } = vopayApi;

export default function useFetchClientCreditCards() {
  const source = axios.CancelToken.source();
  const { CreditCardEnabled } = useLockedFeatures();

  const [pending, setPending] = useState(false);
  const [success, setSuccess] = useState(false);
  const [creditCards, setCreditCards] = useState<vp.ClientCreditCardLists[]>([]);

  useEffect(() => {
    return () => source.cancel();
  }, []);

  async function fetchCreditCards(params: vp.ClientCreditCardsRequest) {
    if (!CreditCardEnabled) return;

    try {
      setPending(true);
      setSuccess(false);
      const res = await api.fetchClientCreditCards(params, source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      const cardsArray = Object.values(res.CreditCards || {});
      setCreditCards(cardsArray);
      setSuccess(true);

      return res;
    } finally {
      setPending(false);
    }
  }
  return {
    pending,
    success,
    creditCards,
    fetchCreditCards,
  };
}
